import { type DocumentState } from "@embedpdf/core";

/* /Rotate as actually applied at display time: the page's own raw rotation
 * combined with any viewer-level rotation the user has additionally applied. */
export function getPageRotation(pageIndex: number, activeDocument: DocumentState | null): number {
  const page = activeDocument?.document?.pages.find(candidate => candidate.index === pageIndex);
  const rawRotation = page?.rotation ?? 0;
  const viewerRotation = activeDocument?.rotation ?? 0;
  return (rawRotation + viewerRotation) % 4;
}
